var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn"},_vm.$listeners),[_vm._t("default"),_vm._v(" "+_vm._s(_vm.text))],2)}
var staticRenderFns = []

export { render, staticRenderFns }